/* eslint-disable react-hooks/exhaustive-deps */
import { getAuth } from "firebase/auth";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import {
  // React,
  useEffect,
  useState,
} from "react";
import { db } from "../../../firebase";

export default function useRealsTimeNotifications() {
  const [Notifications, setNotifications] = useState([]);

  const receiverId = getAuth()?.currentUser?.uid;
  useEffect(async () => {
    const q = query(
      collection(db, "notifications"),
      where("receiver_id", "==", receiverId),
      orderBy("createdAt", "desc")
    );
    await onSnapshot(q, (snapshot) => {
      const realTimeData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setNotifications(realTimeData && realTimeData);
    });
  }, [receiverId]);
  return [Notifications];
}
